import React from "react";

import Header from "./sections/header";
import Body from "./sections/body";
import Footer from "./sections/footer";

function App() {
  return ( 
    <div>
      <Header />
      <Body />
      <Footer /> 
    </div>
  );
}

export default App;
